import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import { getModule } from "vuex-module-decorators";

import rootStore from "@/store";

import BatchInvoice from "./batch-invoice.model";
import FactoryInvoice from "./factory-invoice.model";
import {
  batchFactoryInvoiceTypes,
  getFactoryInvoiceDetailRouteName,
  getFactoryInvoiceTypeName,
} from "./factory-invoice-type.value";
import FactoryInvoiceStore from "./store";

@Component
export default class InvoiceRowsMixin extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fFactoryInvoiceStore: FactoryInvoiceStore;

  constructor() {
    super();
    this.fFactoryInvoiceStore = getModule(FactoryInvoiceStore, rootStore);
  }

  get sampleInvoices(): FactoryInvoice[] {
    const invoices = [
      ...this.fFactoryInvoiceStore.getFactoryInvoicesByPlushieId(
        this.plushieId
      ),
    ];

    return invoices.sort((first, second) => {
      const firstCreatedAt = first.createdAt ? first.createdAt.getTime() : 0;
      const secondCreatedAt = second.createdAt ? second.createdAt.getTime() : 0;

      if (firstCreatedAt !== secondCreatedAt) {
        return secondCreatedAt - firstCreatedAt;
      }

      return first.id < second.id ? 1 : first.id > second.id ? -1 : 0;
    });
  }

  get batchInvoices(): BatchInvoice[] {
    return this.fFactoryInvoiceStore.getBatchInvoicesByBatchPlushieId(
      this.plushieId
    );
  }

  get hasBatchInvoices(): boolean {
    return this.batchInvoices.length > 0;
  }

  get batchInvoiceRows(): Array<{
    invoice: FactoryInvoice;
    batchInvoice: BatchInvoice;
  }> {
    const rows: Array<{
      invoice: FactoryInvoice;
      batchInvoice: BatchInvoice;
    }> = [];

    this.batchInvoices.forEach((batchInvoice) => {
      const invoice = this.fFactoryInvoiceStore.getFactoryInvoiceById(
        batchInvoice.invoiceId
      );

      if (!invoice || !batchFactoryInvoiceTypes.includes(invoice.type)) {
        return;
      }

      rows.push({ batchInvoice, invoice });
    });

    return rows.sort(
      (first, second) => first.invoice.type - second.invoice.type
    );
  }

  get invoiceRows(): Array<{
    invoice: FactoryInvoice;
    batchInvoice?: BatchInvoice;
  }> {
    if (this.hasBatchInvoices) {
      return this.batchInvoiceRows;
    }

    return this.sampleInvoices.map((invoice) => ({ invoice }));
  }

  public getInvoiceRoute(invoice: FactoryInvoice): Location {
    return {
      name: getFactoryInvoiceDetailRouteName(invoice.type),
      query: {
        id: invoice.id,
      },
    };
  }

  public getInvoiceTypeName(
    invoice: FactoryInvoice,
    batchInvoice?: BatchInvoice
  ): string {
    return getFactoryInvoiceTypeName(
      invoice.type,
      batchInvoice && batchInvoice.usedDepositPercent
    );
  }

  public getInvoiceStatusName(invoice: FactoryInvoice): string {
    const status = this.fFactoryInvoiceStore.getInvoiceStatusById(
      invoice.status
    );

    return status ? status.name : "";
  }
}
